<template>
  <Card>
    <template #title>
      {{ titolo }}
      <button
        @click="aperto = !aperto"
        style="float: right; background: none; border: none; cursor: pointer;"
        :aria-label="aperto ? 'Riduci' : 'Espandi'"
        title="Riduci/espandi"
      >
        <span v-if="aperto">&#x2212;</span>
        <span v-else>&#x25A1;</span>
      </button>
    </template>
    <template #content>
      <div v-show="aperto">
      <div>
        <div>
          <table class="giro_settimanale">
            <tbody>
            <tr class="tabella-giro-settimanale">
              <th class="bordo-sinistro-arrotondato">{{ $root.trans.servizi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.lunedi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.martedi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.mercoledi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.giovedi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.venerdi}}</th>
              <th class="sfondo-voci-tabella">{{ $root.trans.giorni_una_lettera.sabato}}</th>
              <th class="bordo-destro-arrotondato">{{ $root.trans.giorni_una_lettera.domenica}}</th>
            </tr>
            <tr class="testo-giro-settimanale" v-for="(item, index) in girosettimanale" :key="index">
              <td class="padding-iniziale-tabella">{{ item.nome}}</td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.lunedi.length">
                  <li v-for="l_gs in item.lunedi" :key="l_gs.id" :style="{ backgroundColor: l_gs.colore }" @click="apriModale(l_gs.id, $root.trans.giorni.lunedi, item.id)" class="giro-settimanale-cella">
                    {{ l_gs.cognome_dip }} {{ l_gs.nome_dip }}<br/>
                    {{ l_gs.ora_inizio.slice(0,5) }} - {{ l_gs.ora_fine.slice(0,5) }}<br/>
                    {{ l_gs.frequenza }}<br/>
                    {{ l_gs.marca }} {{ l_gs.modello }} {{ l_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.martedi.length">
                  <li v-for="m_gs in item.martedi" :key="m_gs.id" :style="{ backgroundColor: m_gs.colore }" @click="apriModale(m_gs.id, $root.trans.giorni.martedi)" class="giro-settimanale-cella">
                    {{ m_gs.cognome_dip }} {{ m_gs.nome_dip }}<br/>
                    {{ m_gs.ora_inizio.slice(0,5) }} - {{ m_gs.ora_fine.slice(0,5) }}<br/>
                    {{ m_gs.frequenza }}<br/>
                    {{ m_gs.marca }} {{ m_gs.modello }} {{ m_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.mercoledi.length">
                  <li v-for="me_gs in item.mercoledi" :key="me_gs.id" :style="{ backgroundColor: me_gs.colore }" @click="apriModale(me_gs.id, $root.trans.giorni.mercoledi)" class="giro-settimanale-cella">
                    {{ me_gs.cognome_dip }} {{ me_gs.nome_dip }}<br/>
                    {{ me_gs.ora_inizio.slice(0,5) }} - {{ me_gs.ora_fine.slice(0,5) }}<br/>
                    {{ me_gs.frequenza }}<br/>
                    {{ me_gs.marca }} {{ me_gs.modello }} {{ me_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.giovedi.length">
                  <li v-for="g_gs in item.giovedi" :key="g_gs.id" :style="{ backgroundColor: g_gs.colore }" @click="apriModale(g_gs.id, $root.trans.giorni.giovedi)" class="giro-settimanale-cella">
                    {{ g_gs.cognome_dip }} {{ g_gs.nome_dip }}<br/>
                    {{ g_gs.ora_inizio.slice(0,5) }} - {{ g_gs.ora_fine.slice(0,5) }}<br/>
                    {{ g_gs.frequenza }}<br/>
                    {{ g_gs.marca }} {{ g_gs.modello }} {{ g_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.venerdi.length">
                  <li v-for="v_gs in item.venerdi" :key="v_gs.id" :style="{ backgroundColor: v_gs.colore }" @click="apriModale(v_gs.id, $root.trans.giorni.venerdi)" class="giro-settimanale-cella">
                    {{ v_gs.cognome_dip }} {{ v_gs.nome_dip }}<br/>
                    {{ v_gs.ora_inizio.slice(0,5) }} - {{ v_gs.ora_fine.slice(0,5) }}<br/>
                    {{ v_gs.frequenza }}<br/>
                    {{ v_gs.marca }} {{ v_gs.modello }} {{ v_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.sabato.length">
                  <li v-for="s_gs in item.sabato" :key="s_gs.id" :style="{ backgroundColor: s_gs.colore }" @click="apriModale(s_gs.id, $root.trans.giorni.sabato)" class="giro-settimanale-cella">
                    {{ s_gs.cognome_dip }} {{ s_gs.nome_dip }}<br/>
                    {{ s_gs.ora_inizio.slice(0,5) }} - {{ s_gs.ora_fine.slice(0,5) }}<br/>
                    {{ s_gs.frequenza }}<br/>
                    {{ s_gs.marca }} {{ s_gs.modello }} {{ s_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
              <td class="padding-iniziale-tabella">
                <ul v-if="item.domenica.length">
                  <li v-for="d_gs in item.domenica" :key="d_gs.id" :style="{ backgroundColor: d_gs.colore }" @click="apriModale(d_gs.id, $root.trans.giorni.domenica)" class="giro-settimanale-cella">
                    {{ d_gs.cognome_dip }} {{ d_gs.nome_dip }}<br/>
                    {{ d_gs.ora_inizio.slice(0,5) }} - {{ d_gs.ora_fine.slice(0,5) }}<br/>
                    {{ d_gs.frequenza }}<br/>
                    {{ d_gs.marca }} {{ d_gs.modello }} {{ d_gs.targa }}
                  </li>
                </ul>
                <div v-else>
                  <span> </span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
        <slot />
      </div>
    </template>
  </Card>
  <p>&nbsp;</p>
  <Card>
    <template #title>{{ titolo2 }}</template>
    <template #content>
      <div  class="flex gap-4">
        <div class="w-1/3 p-4">
          <Button @click="toggleSelection" class="p-button-info">
            {{ tuttiSelezionati ? $root.trans.deselezionare_tutti : $root.trans.selezionare_tutti }}
          </Button>
          <div class="margin-top-20px"> </div>
          <div v-for="dipendente in dipendenti.sort((a, b) => a.cognome_dip.localeCompare(b.cognome_dip))" :key="dipendente.dip" class="mb-1.5">
            <label class="flex intem-center cursor-pointer">
              <Checkbox v-model="dipendentiSelezionati" :value="dipendente.dip" class="focus:ring-0 focus:outline-none"/>
              <span class="testo-giro-settimanale ml-3">{{ dipendente.cognome_dip }} {{ dipendente.nome_dip }}</span>
            </label>
          </div>
        </div>
        <div class="w-2/3 p-4">
          <form @submit.prevent="controllaForm">
            <input type="hidden" name="_token" :value="csrfToken" />
            <input type="hidden" name="_token" :value="csrfToken" />

            <div v-for="dip in dipendentiSelezionati" :key="dip">
              <input type="hidden" name="dipendenti[]" :value="dip" />
            </div>

            <label for="giorno" class="block mb-1 font-semibold color_blu text-sm">{{ $root.trans.seleziona_giorni_settimanali}}</label>
            <div class="grid grid-cols-7 gap-2 bordo-arrotondato-giorni-sett">
              <label v-for="giorno in giorniSettimana" :key="giorno.id" class="flex justify-center items-center space-x-0 p-2 rounded cursor-pointer hover:bg-gray-100 hover:text-[#02324C]" :style="{ '--tw-space-x-reverse': 'none' }" :class="{ 'bg-[#02324C] text-white': giorniSelezionati.includes(giorno.id), '': !giorniSelezionati.includes(giorno.id) }">
                <input type="checkbox" name="giorni[]" :value="giorno.id" class="hidden" v-model="giorniSelezionati" />
                <span :class="{ 'font-bold': giorniSelezionati.includes(giorno.id) }">{{ giorno.nome }}</span>
              </label>
            </div>

            <div class="flex items-center mb-4 mt-3">
              <input type="checkbox" id="datiUguali" name="dati_uguali" v-model="datiUguali" class="w-5 h-5 text-blue-600" />
              <label for="datiUguali" class=" ml-1 font-semibold color_blu text-sm">{{ $root.trans.dati_uguali}}</label>
            </div>
            <div v-if="datiUguali" class="grid grid-cols-3 gap-4 testo-giro-settimanale">
              <div>
                <label for="data_inizio" class="font-semibold block mb-1">{{ $root.trans.data_di_inizio }} *</label>
                <DatePicker v-model="data_inizio" id="data_inizio" showIcon fluid :showOnFocus="true" dateFormat="dd-mm-yy" class="w-full" />
              </div>

              <div>
                <label for="data_fine" class="font-semibold block mb-1">{{ $root.trans.data_fine }} *</label>
                <DatePicker v-model="data_fine" id="data_fine" showIcon fluid :showOnFocus="true" dateFormat="dd-mm-yy" class="w-full" />
              </div>

              <div>
                <label for="frequenzaSelezionata" class="font-semibold block mb-1">{{ $root.trans.frequenza_intervento }} *</label>
                <Select v-model="frequenzaSelezionata" id="frequenzaSelezionata" :options="frequenza" optionLabel="nome" optionValue="id" class="w-full" />
              </div>

              <div>
                <label for="fasciaOrariaSelezionata" class="font-semibold block mb-1">{{ $root.trans.fascia_oraria }}</label>
                <Select v-model="fasciaOrariaSelezionata" id="fasciaOrariaSelezionata" :options="fascia_oraria" optionLabel="nome" optionValue="id" class="w-full" />
              </div>

              <div>
                <label for="ora_inizio" class="font-semibold block mb-1">{{ $root.trans.ora_inizio }}</label>
                <DatePicker v-model="ora_inizio" id="ora_inizio" timeOnly showIcon fluid :showOnFocus="true" dateFormat="hh:mm" :disabled="fasciaOrariaSelezionata > 0" class="w-full" />
              </div>

              <div>
                <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.ora_fine }}</label>
                <DatePicker v-model="ora_fine" id="ora_fine" timeOnly showIcon fluid :showOnFocus="true" dateFormat="hh:mm" :disabled="fasciaOrariaSelezionata > 0" class="w-full" />
              </div>

              <div>
                <label for="automezzoSelezionato" class="font-semibold block mb-1">{{ $root.trans.automezzi }}</label>
                <Select v-model="automezzoSelezionato" id="automezzoSelezionato" :options="automezzi" optionLabel="nome" optionValue="id" class="w-full" filter />
              </div>

              <div>
                <label for="servizioSelezionato" class="font-semibold block mb-1">{{ $root.trans.servizi }}</label>
                <MultiSelect
                  v-model="servizioSelezionato"
                  :options="servizi"
                  optionLabel="servizio"
                  optionValue="contratti_servizi_id"
                  id="servizioSelezionato"
                  class="w-full"
                  filter
                  display="chip"
                />
              </div>

              <div>
                <label for="turno_su_piu_giorni" class="font-semibold block mb-1">{{ $root.trans.turno_su_piu_giorni }}</label>
                <input type="checkbox" id="turno_su_piu_giorni" name="turno_su_piu_giorni" v-model="piuGiorni" class="w-5 h-5 text-blue-600" />
              </div>

              <div class="col-span-3">
                <label for="note" class="font-semibold block mb-1">{{ $root.trans.note }}</label>
                <Editor v-model="note" id="note" editorStyle="height: 200px" class="w-full" />
              </div>

            </div>
            <div v-else>
              <div v-for="(giorno, index) in getGiorniSelezionatiOrdinati()" :key="giorno" class="grid grid-cols-3 gap-4 testo-giro-settimanale">
                <h3 class="font-bold text-lg col-span-3 mt-3">{{ getGiornoNome(giorno) }}</h3>
                <div>
                  <label for="data_inizio" class="font-semibold block mb-1">{{ $root.trans.data_di_inizio }} *</label>
                  <DatePicker v-model="giorno.data_inizio" id="data_inizio" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
                </div>

                <div>
                  <label for="data_fine" class="font-semibold block mb-1">{{ $root.trans.data_fine }} *</label>
                  <DatePicker v-model="giorno.data_fine" id="data_fine" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
                </div>

                <div>
                  <label for="frequenzaSelezionata" class="font-semibold block mb-1">{{ $root.trans.frequenza_intervento }} *</label>
                  <Select v-model="giorno.frequenzaSelezionata" id="frequenzaSelezionata" :options="frequenza" optionLabel="nome" optionValue="id" class="w-full" />
                </div>

                <div>
                  <label for="fasciaOrariaSelezionata" class="font-semibold block mb-1">{{ $root.trans.fascia_oraria }}</label>
                  <Select v-model="giorno.fasciaOrariaSelezionata" id="fasciaOrariaSelezionata" :options="fascia_oraria" optionLabel="nome" optionValue="id" class="w-full" @change="(e) => updateFasciaOraria(e.value, index)" />
                </div>

                <div>
                  <label for="ora_inizio" class="font-semibold block mb-1">{{ $root.trans.ora_inizio }}</label>
                  <DatePicker v-model="giorno.ora_inizio" id="ora_inizio" timeOnly showIcon fluid :showOnFocus="false" dateFormat="hh:mm" :disabled="giorno.fasciaOrariaSelezionata > 0" class="w-full" />
                </div>

                <div>
                  <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.ora_fine }}</label>
                  <DatePicker v-model="giorno.ora_fine" id="ora_fine" timeOnly showIcon fluid :showOnFocus="false" dateFormat="hh:mm" :disabled="giorno.fasciaOrariaSelezionata > 0" class="w-full" />
                </div>

                <div>
                  <label for="automezzoSelezionato" class="font-semibold block mb-1">{{ $root.trans.automezzi }}</label>
                  <Select v-model="giorno.automezzoSelezionato" id="automezzoSelezionato" :options="automezzi" optionLabel="nome" optionValue="id" class="w-full" filter />
                </div>

                <div>
                  <label for="servizioSelezionato" class="font-semibold block mb-1">{{ $root.trans.servizi }}</label>
                  <MultiSelect
                    v-model="giorno.servizioSelezionato"
                    :options="servizi"
                    optionLabel="servizio"
                    optionValue="contratti_servizi_id"
                    id="servizioSelezionato"
                    class="w-full"
                    filter
                    display="chip"
                  />
                </div>

                <div>
                  <label for="turno_su_piu_giorni" class="font-semibold block mb-1">{{ $root.trans.turno_su_piu_giorni }}</label>
                  <input type="checkbox" id="turno_su_piu_giorni" name="turno_su_piu_giorni" v-model="giorno.piuGiorni" class="w-5 h-5 text-blue-600" />
                </div>

                <div class="col-span-3">
                  <label for="note" class="font-semibold block mb-1">{{ $root.trans.note }}</label>
                  <Editor v-model="giorno.note" id="note" editorStyle="height: 200px" class="w-full" />
                </div>

                <div  v-if="index < giorniSelezionati.length - 1"  class="col-span-3 mt-4 mb-2"  :style="{ borderBottom: `2px solid ${getColor(index)}` }">
                </div>
              </div>
            </div>
            <Button type="submit" class="p-button p-component p-button-success mt-[10px]">{{ $root.trans.salva }}</Button>
          </form>
        </div>
      </div>
    </template>
  </Card>
  <!-- Modale -->
  <Dialog v-model:visible="showModal" :header="$root.trans.giro_settimanale + `- ${modal_nomeGiorno}`" :modal="true" :draggable="false">
    <form @submit.prevent="controllaFormModale">
      <input type="hidden" name="_token" :value="csrfToken" />
      <input type="hidden" name="planner_giro_settimanale" :value="modal_planner_giro_settimanale" />

      <div class="grid grid-cols-3 gap-4 testo-giro-settimanale modal-scrollabile">
        <div>
          <label for="modal_data_inizio" class="font-semibold block mb-1">{{ $root.trans.data_di_inizio }} *</label>
          <DatePicker v-model="modal_data_inizio" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
        </div>

        <div>
          <label for="modal_data_fine" class="font-semibold block mb-1">{{ $root.trans.data_fine }} *</label>
          <DatePicker v-model="modal_data_fine" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
        </div>

        <div>
          <label for="modal_frequenzaSelezionata" class="font-semibold block mb-1">{{ $root.trans.frequenza_intervento }} *</label>
          <Select v-model="modal_frequenzaSelezionata" :options="frequenza" optionLabel="nome" optionValue="id" class="w-full" />
        </div>

        <div>
          <label for="modal_fasciaOrariaSelezionata" class="font-semibold block mb-1">{{ $root.trans.fascia_oraria }}</label>
          <Select v-model="modal_fasciaOrariaSelezionata" :options="fascia_oraria" optionLabel="nome" optionValue="id" class="w-full" />
        </div>

        <div>
          <label for="modal_ora_inizio" class="font-semibold block mb-1">{{ $root.trans.ora_inizio }}</label>
          <DatePicker v-model="modal_ora_inizio" timeOnly showIcon fluid :showOnFocus="false" dateFormat="hh:mm"
                      :disabled="modal_fasciaOrariaSelezionata > 0" class="w-full" />
        </div>

        <div>
          <label for="modal_ora_fine" class="font-semibold block mb-1">{{ $root.trans.ora_fine }}</label>
          <DatePicker v-model="modal_ora_fine" timeOnly showIcon fluid :showOnFocus="false" dateFormat="hh:mm"
                      :disabled="modal_fasciaOrariaSelezionata > 0" class="w-full" />
        </div>

        <div>
          <label for="modal_automezzoSelezionato" class="font-semibold block mb-1">{{ $root.trans.automezzi }}</label>
          <Select v-model="modal_automezzoSelezionato" filter :options="automezzi" optionLabel="nome" optionValue="id" class="w-full" />
        </div>

        <div>
          <label for="modal_servizioSelezionato" class="font-semibold block mb-1">{{ $root.trans.servizi }}</label>
          <MultiSelect
            v-model="modal_servizioSelezionato"
            :options="servizi"
            optionLabel="servizio"
            optionValue="contratti_servizi_id"
            id="servizioSelezionato"
            class="w-full"
            filter
            display="chip"
          />
        </div>

        <div>
          <label for="turno_su_piu_giorni" class="font-semibold block mb-1">{{ $root.trans.turno_su_piu_giorni }}</label>
          <input type="checkbox" id="turno_su_piu_giorni" name="turno_su_piu_giorni" v-model="modal_piuGiorni" class="w-5 h-5 text-blue-600" :true-value="1" :false-value="0" />
        </div>

        <div class="col-span-3">
          <label class="font-semibold block mb-2">{{ $root.trans.dipendenti }}</label>
          <button
            type="button"
            class="mb-2 px-3 py-1 bg-gray-200 rounded font-semibold text-xs"
            @click="toggleSelezionaTutti"
          >
            {{ tuttiSelezionati ? $root.trans.deseleziona_tutti : $root.trans.seleziona_tutti }}
          </button>

          <div class="grid grid-cols-4">
            <label
              v-for="m_dipendente in modal_dipendenti.sort((a, b) => a.cognome_dip.localeCompare(b.cognome_dip))"
              :key="m_dipendente.dip"
              class="flex items-center cursor-pointer p-1 rounded-lg">
              <Checkbox v-model="modal_dipendentiSelezionati" :value="m_dipendente.dip" class="mr-2" />
              <span>{{ m_dipendente.cognome_dip }} {{ m_dipendente.nome_dip }}</span>
            </label>
          </div>
        </div>
      </div>

        <div class="col-span-3">
          <label for="modal_note" class="font-semibold block mb-1">{{ $root.trans.note }}</label>
          <Editor v-model="modal_note" editorStyle="height: 200px" class="w-full" />
        </div>

      <div class="flex justify-end mt-6">
        <Button type="button" class="p-button-danger px-4 py-2" @click="confermaEliminazione">{{ $root.trans.elimina }}</Button>
        <Button type="submit" class="p-button p-component p-button-success ml-4 px-4 py-2">{{ $root.trans.salva }}</Button>
      </div>
    </form>
  </Dialog>

</template>

<script>
import axios from 'axios';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import DatePicker from 'primevue/datepicker';
import Select from 'primevue/select';
import Dialog from 'primevue/dialog';
import Editor from 'primevue/editor';
import MultiSelect from 'primevue/multiselect';

export default {
  name: "GiroSettimanale",
  props: ["titolo","titolo2", "dipendenti", "frequenza", "automezzi", "fascia_oraria","contratto_id", "servizi", "girosettimanale"],
  components: {
    Button,
    Card,
    DatePicker,
    Checkbox,
    Select,
    Dialog,
    Editor,
    MultiSelect
  },
  data() {
    return {
      giornoSelezionato: "",
      showModal: false,
      dipendentiSelezionati: [],
      giorniSelezionati: [],
      tuttiSelezionati: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      datiUguali: true,
      data_inizio: null,
      data_fine: null,
      ora_inizio: null,
      ora_fine: null,
      frequenzaSelezionata: null,
      fasciaOrariaSelezionata: null,
      automezzoSelezionato: null,
      contratto_id: this.contratto_id,
      modal_fasciaOrariaSelezionata: null,
      modal_ora_inizio: null,
      modal_ora_fine: null,
      modal_planner_giro_settimanale: 0,
      modal_dipendentiSelezionati: [],
      modal_note: '',
      note: '',
      giorniSelezionatiMap: {}, // Add this line to store data for each day
      modal_nomeGiorno: '', // Add this line to fix undefined modal_nomeGiorno
      piuGiorni: null,
      servizioSelezionato: [],
      aperto: true
    };
  },
  computed: {
    giorniSettimana() {
      return [
        { id: 1, nome: this.$root.trans.giorni.lunedi },
        { id: 2, nome: this.$root.trans.giorni.martedi },
        { id: 3, nome: this.$root.trans.giorni.mercoledi },
        { id: 4, nome: this.$root.trans.giorni.giovedi },
        { id: 5, nome: this.$root.trans.giorni.venerdi },
        { id: 6, nome: this.$root.trans.giorni.sabato },
        { id: 7, nome: this.$root.trans.giorni.domenica }
      ];
    },
    tuttiSelezionati() {
      if (!this.modal_dipendenti || !this.modal_dipendenti.length) return false;
      return (
        this.modal_dipendenti.length === this.modal_dipendentiSelezionati.length
      );
    },
  },

  watch: {
    dipendentiSelezionati() {
      this.tuttiSelezionati = this.dipendentiSelezionati.length === this.dipendenti.length;
    },
    giorniSelezionati: {
      handler(newVal, oldVal) {
        // Initialize data for newly added days
        newVal.forEach(giornoId => {
          if (!this.giorniSelezionatiMap[giornoId]) {
            this.giorniSelezionatiMap[giornoId] = {
              id: giornoId,
              data_inizio: null,
              data_fine: null,
              ora_inizio: null,
              ora_fine: null,
              frequenzaSelezionata: null,
              fasciaOrariaSelezionata: null,
              automezzoSelezionato: null,
              note: '',
              servizioSelezionato: [],
              piuGiorni: null,
            };
          }
        });

        // Remove data for days that were deselected
        Object.keys(this.giorniSelezionatiMap).forEach(giornoId => {
          if (!newVal.includes(parseInt(giornoId))) {
            delete this.giorniSelezionatiMap[giornoId];
          }
        });
      },
      deep: true
    },
    fasciaOrariaSelezionata(id, giornoIndex = null) {
      if (this.datiUguali) {
        if (id == 0) {
          this.ora_inizio = null;
          this.ora_fine = null;
        } else {
          axios.post(route("planner/impostazioni/axios_fascia_oraria"), {id: id})
              .then(response => {
                console.log(response.data);
                this.ora_inizio = response.data.ora_inizio;
                this.ora_fine = response.data.ora_fine;
              })
              .catch(error => {
                console.error("Errore nel recupero della fascia oraria:", error);
              });
        }
      } else {
        if (giornoIndex !== null) {
          if (id == 0) {
            console.log('quii');
            this.giorniSelezionati[giornoIndex].ora_inizio = null;
            this.giorniSelezionati[giornoIndex].ora_fine = null;
          } else {
            axios.post(route("planner/impostazioni/axios_fascia_oraria"), {id: id})
                .then(response => {
                  console.log(response.data);
                  console.log('qui');
                  this.giorniSelezionati[giornoIndex].ora_inizio = response.data.ora_inizio;
                  this.giorniSelezionati[giornoIndex].ora_fine = response.data.ora_fine;
                })
                .catch(error => {
                  console.error("{{ $root.trans.errore_recupero_fascia_oraria }}", error);
                });
          }
        }
      }
    },
    modal_fasciaOrariaSelezionata(id) {
      if (id == 0) {
        this.modal_ora_inizio = null;
        this.modal_ora_fine = null;
      } else {
        axios.post(route("planner/impostazioni/axios_fascia_oraria"), {id: id})
            .then(response => {
              console.log(response.data);
              this.modal_ora_inizio = response.data.ora_inizio;
              this.modal_ora_fine = response.data.ora_fine;
            })
            .catch(error => {
              console.error("{{ $root.trans.errore_recupero_fascia_oraria }}", error);
            });
      }
    },
  },
  methods: {
    getGiorniSelezionatiOrdinati() {
      const giorniOrdinati = [
        this.$root.trans.giorni.lunedi,
        this.$root.trans.giorni.martedi,
        this.$root.trans.giorni.mercoledi,
        this.$root.trans.giorni.giovedi,
        this.$root.trans.giorni.venerdi,
        this.$root.trans.giorni.sabato,
        this.$root.trans.giorni.domenica
      ];

      return this.giorniSelezionati
        .slice()
        .sort((a, b) => {
          const giornoA = this.getGiornoNome(a);
          const giornoB = this.getGiornoNome(b);
          return giorniOrdinati.indexOf(giornoA) - giorniOrdinati.indexOf(giornoB);
        })
        .map(giornoId => this.giorniSelezionatiMap[giornoId]); // Return the actual objects
    },
    updateFasciaOraria(fasciaId, giornoId) {
      console.log(giornoId, fasciaId);
      console.log(this.giorniSelezionati[giornoId]);
      const giorno = this.getGiorniSelezionatiOrdinati()[giornoId];
      if (fasciaId == 0) {
        giorno.ora_inizio = null;
        giorno.ora_fine = null;
      } else {
        axios.post(route("planner/impostazioni/axios_fascia_oraria"), {id: fasciaId})
          .then(response => {
            console.log(response.data);
            giorno.ora_inizio = response.data.ora_inizio;
            giorno.ora_fine = response.data.ora_fine;
          })
          .catch(error => {
            console.error("Errore nel recupero della fascia oraria:", error);
          });
      }
    },
    getGiornoNome(giornoId) {
      // Se giornoId è un oggetto, estraiamo l'id
      const id = typeof giornoId === 'object' ? giornoId.id : giornoId;
      const giorno = this.giorniSettimana.find(g => Number(g.id) === Number(id));
      return giorno ? giorno.nome : this.$root.trans.giorni.non_valido;
    },
    getColor(index) {
      const colors = ["#ACC9E9", "#D7D8B6", "#F0D6A5", "#999999B2", "#FDDFD3", "#E9EBD7"];
      return colors[index % colors.length];
    },
    toggleSelection() {
      if (this.tuttiSelezionati) {
        this.dipendentiSelezionati = [];
      } else {
        this.dipendentiSelezionati = this.dipendenti.map(d => d.dip);
      }
      this.tuttiSelezionati = !this.tuttiSelezionati;
    },
    controllaForm() {
      let errore = 0;
      let datiForm = [];
      if (this.datiUguali) {
        datiForm.push({
          dipendenti: this.dipendentiSelezionati,
          giorni: this.giorniSelezionati,
          dati_uguali: this.datiUguali,
          data_inizio: this.data_inizio,
          data_fine: this.data_fine,
          ora_inizio: this.ora_inizio,
          ora_fine: this.ora_fine,
          frequenza: this.frequenzaSelezionata,
          fascia_oraria: this.fasciaOrariaSelezionata,
          automezzo: this.automezzoSelezionato,
          giorni_selezionati: this.giorniSelezionati,
					note: this.note,
          contratto_id: this.contratto_id,
          piu_giorni: this.piuGiorni,
          servizio_selezionato: this.servizioSelezionato,
        });

        if (this.dipendentiSelezionati.length === 0) {
          alert(this.$root.trans.selezionare_dipendente);
          errore++;
          return;
        }
        if (this.giorniSelezionati.length === 0) {
          alert(this.$root.trans.selezionare_giorno);
          errore++;
          return;
        }
        if (!this.data_inizio) {
          alert(this.$root.trans.data_inizio_vuoto);
          errore++;
          return;
        }
        if (!this.data_fine) {
          alert(this.$root.trans.data_fine_vuoto);
          errore++;
          return;
        }
        if (this.data_inizio && this.data_fine && new Date(this.data_inizio) > new Date(this.data_fine)) {
          alert(this.$root.trans.data_inizio_maggiore_data_fine);
          errore++;
          return;
        }
        if (this.ora_inizio && this.ora_fine && new Date(`1970-01-01T${this.ora_inizio}:00`) > new Date(`1970-01-01T${this.ora_fine}:00`)) {
          alert(this.$root.trans.ora_inizio_maggiore_ora_fine);
          errore++;
          return;
        }
      } else {
        for (const giornoId of this.giorniSelezionati) {
          const giorno = this.giorniSelezionatiMap[giornoId];

          if (!giorno.data_inizio) {
            alert(this.$root.trans.data_inizio_vuoto);
            errore++;
            return;
          }

          if (!giorno.data_fine) {
            alert(this.$root.trans.data_fine_vuoto);
            errore++;
            return;
          }

          if (new Date(giorno.data_inizio) > new Date(giorno.data_fine)) {
            alert(this.$root.trans.data_inizio_maggiore_data_fine);
            errore++;
            return;
          }

          if (giorno.ora_inizio && giorno.ora_fine &&
            new Date(`1970-01-01T${giorno.ora_inizio}:00`) > new Date(`1970-01-01T${giorno.ora_fine}:00`)) {
            alert(this.$root.trans.ora_inizio_maggiore_ora_fine);
            errore++;
            return;
          }

          datiForm.push({
            dipendenti: this.dipendentiSelezionati,
            dati_uguali: this.datiUguali,
            giorno_id: giornoId,
            data_inizio: giorno.data_inizio,
            data_fine: giorno.data_fine,
            ora_inizio: giorno.ora_inizio,
            ora_fine: giorno.ora_fine,
            frequenza: giorno.frequenzaSelezionata,
            fascia_oraria: giorno.fasciaOrariaSelezionata,
            automezzo: giorno.automezzoSelezionato || 0,
            note: giorno.note,
            contratto_id: this.contratto_id,
            piu_giorni: giorno.piuGiorni,
            servizio_selezionato: giorno.servizioSelezionato,
          });
        }
      }

      console.log("Dati form:", datiForm);
      if (errore == 0) {
        this.submitForm(datiForm);
      }
    },
    submitForm(dati) {
      console.log(dati)
      axios.post(route("clienti/cantieri/contratti/salva_giro_settimanale"), dati)
          .then(response => {
            console.log("Risposta server:", response.data);
            window.location.reload();
          })
          .catch(error => {
            console.error("Errore nel salvataggio:", error);

            if (error.response) {
              console.error("Errore dettagliato:", error.response.data);
              alert(error.response.data.message || "Si è verificato un errore durante il salvataggio.");
            } else if (error.request) {
              alert("Errore di connessione: Nessuna risposta dal server.");
            } else {
              alert("Errore sconosciuto. Controlla la console per maggiori dettagli.");
            }
          });
    },
    apriModale(girosettimanale_id, nomeGiorno, servizio_id) {
      if(servizio_id > 0) { var array_servizi = [servizio_id]; } else { var array_servizi = [] }
      axios.post(route("clienti/cantieri/contratti/get_giro_settimanale"), {id: girosettimanale_id})
          .then(response => {
            console.log('qui');
            console.log(response.data);
            console.log(response.data.piu_giorni);
            this.modal_planner_giro_settimanale = girosettimanale_id;
            this.modal_data_inizio = response.data.data_inizio ? new Date(response.data.data_inizio) : null;
            this.modal_data_fine = response.data.data_fine ? new Date(response.data.data_fine) : null;
            this.modal_ora_inizio = response.data.ora_inizio.slice(0,5);
            this.modal_ora_fine = response.data.ora_fine.slice(0,5);
            this.modal_frequenzaSelezionata = response.data.plannertipofrequenza_id || 0;
            this.modal_fasciaOrariaSelezionata = response.data.fascia_oraria || 0;
            this.modal_automezzoSelezionato = response.data.automezzi_id || 0;
            this.$nextTick(() => {
              this.modal_note = response.data.note || '';
            });
            this.modal_dipendenti = response.data.dipendenti || [];
            this.modal_dipendentiSelezionati = response.data.dipendenti.filter(d => d.checked == 1).map(d => d.dip);
            this.modal_nomeGiorno = nomeGiorno;
            this.modal_piuGiorni = response.data.piu_giorni;
            this.modal_servizioSelezionato = array_servizi;
            this.showModal = true;
          })
          .catch(error => {
            console.error("Errore nel recupero della fascia oraria:", error);
          });
    },
    controllaFormModale() {
      let errore = 0;
      let datiForm = [];
      datiForm.push({
        giro_settimanale: this.modal_planner_giro_settimanale,
        data_inizio: this.modal_data_inizio,
        data_fine: this.modal_data_fine,
        ora_inizio: this.modal_ora_inizio,
        ora_fine: this.modal_ora_fine,
        frequenza: this.modal_frequenzaSelezionata,
        fascia_oraria: this.modal_fasciaOrariaSelezionata,
        automezzo: this.modal_automezzoSelezionato || 0,
        note: this.modal_note,
        dipendenti: this.modal_dipendentiSelezionati,
        piu_giorni: this.modal_piuGiorni,
        servizio_selezionato: this.modal_servizioSelezionato,
      });

      if (this.modal_dipendentiSelezionati.length === 0) {
        alert(this.$root.trans.selezionare_dipendente);
        errore++;
        return;
      }

      if (!this.modal_data_inizio) {
        alert(this.$root.trans.data_inizio_vuoto);
        errore++;
        return;
      }
      if (!this.modal_data_fine) {
        alert(this.$root.trans.data_fine_vuoto);
        errore++;
        return;
      }
      if (this.modal_data_inizio && this.modal_data_fine && new Date(this.modal_data_inizio) > new Date(this.modal_data_fine)) {
        alert(this.$root.trans.data_inizio_maggiore_data_fine);
        errore++;
        return;
      }
      /*if (this.modal_ora_inizio && this.modal_ora_fine && new Date(`1970-01-01T${this.modal_ora_inizio}:00`) > new Date(`1970-01-01T${this.modal_ora_fine}:00`)) {
        alert(this.$root.trans.ora_inizio_maggiore_ora_fine);
        errore++;
        return;
      }*/

      console.log("Dati form:", datiForm);
      if (errore == 0) {
        this.submitFormModal(datiForm);
      }
    },
    submitFormModal(dati) {
      console.log(dati)
      axios.post(route("clienti/cantieri/contratti/modifica_giro_settimanale"), dati)
          .then(response => {
            console.log("Risposta server:", response.data);
            window.location.reload();
          })
          .catch(error => {
            console.error("Errore nel salvataggio:", error);

            if (error.response) {
              console.error("Errore dettagliato:", error.response.data);
              alert(error.response.data.message || "Si è verificato un errore durante il salvataggio.");
            } else if (error.request) {
              alert("Errore di connessione: Nessuna risposta dal server.");
            } else {
              alert("Errore sconosciuto. Controlla la console per maggiori dettagli.");
            }
          });
    },
    confermaEliminazione() {
      //"Sei sicuro di voler eliminare questo piano settimanale? Questa azione è irreversibile!"
      //alert("Errore durante l'eliminazione del piano settimanale.");
      if (confirm(this.$root.trans.elimina_piano_settimanale)) {
        let datiForm = [];
        datiForm.push({
          giro_settimanale: this.modal_planner_giro_settimanale,
          data_inizio: this.modal_data_inizio,
          data_fine: this.modal_data_fine,
          ora_inizio: this.modal_ora_inizio,
          ora_fine: this.modal_ora_fine,
          frequenza: this.modal_frequenzaSelezionata,
          fascia_oraria: this.modal_fasciaOrariaSelezionata,
          automezzo: this.modal_automezzoSelezionato,
          note: this.modal_note,
          dipendenti: this.modal_dipendentiSelezionati,
        });
        axios.post(route("clienti/cantieri/contratti/elimina_giro_settimanale"), datiForm)
            .then(response => {
              alert(this.$root.trans.eliminato_piano_settimanale);
              this.showModal = false;
              window.location.reload();
            })
            .catch(error => {
              console.error("Errore durante l'eliminazione:", error);
              alert(this.$root.trans.errore_eliminato_piano_settimanale);
            });
      }
    },
    toggleSelezionaTutti() {
      if (this.tuttiSelezionati) {
        this.modal_dipendentiSelezionati = [];
      } else {
        this.modal_dipendentiSelezionati = this.modal_dipendenti.map((d) => d.dip);
      }
    },

  }
};
</script>
